export const formatSortCode = (sortCode: string) => {
  const formattedSortCode: Array<string> = sortCode.replace(/-/g, '').split('');
  formattedSortCode.splice(2, 0, '-');
  formattedSortCode.splice(5, 0, '-');
  return formattedSortCode.join('');
};
